<template>
  <Fragment>
    <BaseIcon
      v-bind="$attrs"
      :id="id"
      :icon="$props.icon"
      tag="a"
      role="button"
      class="text-white bg-primary ml-2"
    />

    <b-popover :target="id" trigger="focus">
      <div class="py-2 px-3">
        <slot />
      </div>
    </b-popover>
  </Fragment>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api'
import { Fragment } from 'vue-fragment'
import { uniqueId } from 'lodash-es'

import { BaseIcon } from '@components/base'

export default defineComponent({
  name: 'HelperIcon',
  components: {
    Fragment,

    BaseIcon
  },
  props: {
    icon: {
      type: String,
      default: 'question'
    }
  },
  setup() {
    const id = computed(() => uniqueId('helper-popover-'))

    return {
      id
    }
  }
})
</script>
